import React from 'react';
import { Tag, Tooltip } from 'antd';

/**
 * An orange "Absence" tag for a day an agent has an absence notification.
 *
 * `absences` is the notifications covering the day -- anything not canceled.
 * Hover for the details; click to open the first one, but only when the viewer
 * can see absences (`canOpen`), since the page would send anyone else away.
 */
export default function AbsenceTag({ absences, navigate, canOpen }) {
  if (!absences?.length) return null;
  const detail = (
    <div>
      {absences.map((a) => (
        <div key={a.ID} style={{ marginBottom: absences.length > 1 ? 6 : 0 }}>
          <div><strong>{a.Reason || 'Absence'}</strong></div>
          <div>{a.AbsencePeriod}</div>
          {a.StartTime && a.EndTime && <div>{String(a.StartTime).slice(0, 5)} – {String(a.EndTime).slice(0, 5)}</div>}
          {a.DateEnd && String(a.DateEnd).slice(0, 10) !== String(a.DateStart).slice(0, 10) && (
            <div>{String(a.DateStart).slice(0, 10)} to {String(a.DateEnd).slice(0, 10)}</div>
          )}
          <div>{a.Status}</div>
        </div>
      ))}
    </div>
  );
  return (
    <Tooltip title={detail}>
      <Tag
        color="orange"
        style={{ margin: 0, fontSize: 11, lineHeight: '16px', cursor: canOpen ? 'pointer' : 'default' }}
        onClick={canOpen ? (e) => { e.stopPropagation(); navigate(`/absences/${absences[0].ID}`); } : undefined}
      >
        Absence
      </Tag>
    </Tooltip>
  );
}
